import React from 'react';
import MaterialTablePagination, {
    TablePaginationProps as MaterialTablePaginationProps,
} from '@mui/material/TablePagination';
import styled from 'styled-components';

const StyledTablePagination = styled(({ ...props }: MaterialTablePaginationProps) => (
    <MaterialTablePagination {...props} />
))``;

export type TablePaginationProps = MaterialTablePaginationProps & {
    component?: React.ElementType;
};

const TablePagination: React.FunctionComponent<TablePaginationProps> = (props) => {
    return <StyledTablePagination {...props} />;
};

export default TablePagination;
